export interface CommunicationChannel {
  name: string;
  icon: string;
  phoneNumber?: string;
  enabled?: boolean;
  callback: () => void;
}

export const getInitialChannels = (
  homeEntries: Record<string, Record<string, unknown>>,
  askCallback: () => void,
  callCallback: () => void,
  whatsAppCallback: () => void
): CommunicationChannel[] => [
  {
    name: "ask",
    icon: "JP-Document-copy",
    enabled: homeEntries?.ask.enabled as boolean,
    callback: askCallback,
  },
  {
    name: "call",
    icon: "JP-Phone",
    enabled: homeEntries?.call.enabled as boolean,
    callback: callCallback,
  },
  {
    name: "whatsapp",
    icon: "JP-Whatsapp",
    enabled: homeEntries?.whatsapp.enabled as boolean,
    callback: whatsAppCallback,
  },
];
